import { z } from "zod/v4";

export const WorkspaceSchema = z.object({
	id: z.string(),
	name: z.string().default(""),
	host: z.string().default(""), // generally git.moment.dev
	slug: z.string().default(""),
	role: z.enum(["owner", "member", "guest"]).default("guest"),
	owner: z.boolean().default(false),
	paymentStatus: z.string().nullish(),
	avatarUrl: z.string().nullish(),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;

export const isPersonalWorkspace = (workspace: Workspace): boolean => {
	if (!workspace) {
		return false;
	}
	return workspace.id.startsWith("github");
};
